import { z } from 'zod';
/** Per-book plans. Values match the `BookPlan` enum in Prisma. */
export const BOOK_PLAN_IDS = ['book', 'live_book', 'gift_book'];
export const BookPlanIdSchema = z.enum(BOOK_PLAN_IDS);
/**
 * Extra pack after the included replacements are used up (§5 of monetization).
 * The price does not live here: each brand has its own, see `BrandConfig.imagePackPrice`.
 */
export const IMAGE_REPLACEMENT_PACK = {
    count: 5,
};
/**
 * Single source of truth for the API and web. The price is fixed on the book at test
 * payment time, so a later catalog change does not rewrite an old purchase.
 */
export const BOOK_PLANS = {
    book: {
        id: 'book',
        sceneCount: 7,
        maxCharacters: 3,
        maxThings: 1,
        maxLocations: 1,
        imageResolution: '1k',
        video: { enabled: false, durationSec: 0, resolution: '720p' },
        narration: false,
        printReady: true,
        printQuality: 'standard',
        freeImageReplacements: 2,
    },
    live_book: {
        id: 'live_book',
        sceneCount: 9,
        maxCharacters: 4,
        maxThings: 3,
        maxLocations: 3,
        imageResolution: '1k',
        video: { enabled: true, durationSec: 5, resolution: '720p' },
        narration: false,
        printReady: true,
        printQuality: 'standard',
        freeImageReplacements: 5,
    },
    gift_book: {
        id: 'gift_book',
        sceneCount: 11,
        maxCharacters: 6,
        maxThings: 5,
        maxLocations: 5,
        imageResolution: '2k',
        video: { enabled: true, durationSec: 5, resolution: '1080p' },
        narration: true,
        printReady: true,
        printQuality: 'high',
        freeImageReplacements: 10,
    },
};
export function bookPlan(id) {
    return BOOK_PLANS[id];
}
//# sourceMappingURL=plans.js.map